module.exports = __webpack_public_path__ + "img/i-zcy-bg-4.6af38a38.png";